import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const InstallPrompt = () => {
    const { t } = useTranslation();
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showPrompt, setShowPrompt] = useState(false);
    useEffect(() => {
        // Check if already installed
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone ||
            document.referrer.includes('android-app://');
        // Check if mobile device
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
            (window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
        console.log('PWA Install Debug:', {
            isStandalone,
            isMobile,
            userAgent: navigator.userAgent,
            isSecureContext: window.isSecureContext,
            serviceWorker: 'serviceWorker' in navigator
        });
        if (isStandalone) {
            console.log('App is already installed');
            return;
        }
        if (!isMobile) {
            console.log('Not a mobile device, skipping install prompt');
            return;
        }
        const handleBeforeInstallPrompt = (event) => {
            console.log("beforeinstallprompt event fired!");
            // Prevent the default prompt
            event.preventDefault();
            // Save the event for later use
            setDeferredPrompt(event);
            // Show our custom install prompt
            setShowPrompt(true);
        };
        const handleAppInstalled = () => {
            console.log('PWA was installed');
            setDeferredPrompt(null);
            setShowPrompt(false);
        };
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        window.addEventListener('appinstalled', handleAppInstalled);
        // Check if the event is supported
        console.log('beforeinstallprompt supported:', 'onbeforeinstallprompt' in window);
        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            window.removeEventListener('appinstalled', handleAppInstalled);
        };
    }, []);
    const handleInstallClick = async () => {
        if (!deferredPrompt)
            return;
        // Show the install prompt
        deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`User response to the install prompt: ${outcome}`);
        // Clear the deferred prompt
        setDeferredPrompt(null);
        setShowPrompt(false);
    };
    const handleDismiss = () => {
        setShowPrompt(false);
        // Optionally, you can set a flag in localStorage to not show again for some time
        localStorage.setItem('pwa-install-dismissed', Date.now().toString());
    };
    if (!showPrompt)
        return null;
    return (_jsx("div", { className: "install-prompt", children: _jsxs("div", { className: "install-prompt-content", children: [_jsx("div", { className: "install-prompt-icon", children: _jsxs("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M12 2L2 7V12C2 16.5 4.23 20.68 7.62 23.15L12 21L16.38 23.15C19.77 20.68 22 16.5 22 12V7L12 2Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M12 8V16M12 16L9 13M12 16L15 13", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] }) }), _jsxs("div", { className: "install-prompt-text", children: [_jsx("h3", { children: t('install.title', 'Install KVC Rally') }), _jsx("p", { children: t('install.description', 'Install the app for a better experience') })] }), _jsxs("div", { className: "install-prompt-actions", children: [_jsx("button", { className: "install-prompt-button install-prompt-button--dismiss", onClick: handleDismiss, children: t('button.dismiss', 'Not now') }), _jsx("button", { className: "install-prompt-button install-prompt-button--primary", onClick: handleInstallClick, children: t('button.install', 'Install') })] })] }) }));
};
export default InstallPrompt;
